import React from 'react'
import { Region, transformRegionToMap } from 'msp-integrations'
import { twMerge } from 'tailwind-merge'
import Grid from '@atoms/Grid/Grid'

const COMPONENTS_WITH_PADDING_IN_GRID_COLUMN = [
  'pwa.richText',
  'pwa.customLink',
  'pwa.dynamicTagLink'
]

const GridWrapper = ({
  data,
  regions
}: {
  data: any
  regions: Array<any>
  custom?: any
}) => {
  const col1Content = transformRegionToMap(regions).get('col1')
  const col2Content = transformRegionToMap(regions).get('col2')
  const col3Content = transformRegionToMap(regions).get('col3')

  const isTextContent = (colContent: any) =>
    COMPONENTS_WITH_PADDING_IN_GRID_COLUMN.some(
      (c) =>
        colContent?.components &&
        colContent?.components.some((c2: any) => c2?.type_id === c)
    )

  const colStyle = 'w-full flex justify-center'
  return (
    <Grid
      wrapperStyles={`grid-cols-1 gap-y-6 lg:gap-y-0
      ${data.colCount === '3' ? 'lg:grid-cols-3' : 'lg:grid-cols-2'}`}
    >
      <Region
        region={col1Content}
        className={twMerge(
          colStyle,
          isTextContent(col1Content) ? 'px-7 py-4 md:px-7 md:py-7' : ''
        )}
      />
      <Region
        region={col2Content}
        className={twMerge(
          colStyle,
          isTextContent(col2Content) ? 'px-7 py-4 md:px-7 md:py-7' : ''
        )}
      />
      {data.colCount === '3' && (
        <Region
          region={col3Content}
          className={twMerge(
            colStyle,
            isTextContent(col3Content) ? 'px-7 py-4 md:px-7 md:py-7' : ''
          )}
        />
      )}
    </Grid>
  )
}

export default GridWrapper
